export default __webpack_public_path__ + "static/media/souq.1aaf2538.jpg";